/**
 * One chat message bubble. User messages are right-aligned plain text;
 * assistant messages are left-aligned and host rich children (reasoning,
 * streamed markdown, sources, draft card). Surface-agnostic.
 */

import React from 'react';
import { Box } from '@mui/material';

interface MessageBubbleProps {
  role: 'user' | 'assistant';
  children: React.ReactNode;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ role, children }) => {
  const isUser = role === 'user';
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
      }}
    >
      <Box
        sx={{
          maxWidth: isUser ? '85%' : '100%',
          px: 1.5,
          py: 1,
          borderRadius: 2,
          bgcolor: isUser ? 'primary.main' : 'grey.100',
          color: isUser ? 'primary.contrastText' : 'text.primary',
          whiteSpace: isUser ? 'pre-wrap' : 'normal',
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default React.memo(MessageBubble);
